import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Header from './Header';
import './TaskList.css';

function TaskList({ user, onLogout }) {
  const [searchParams] = useSearchParams();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    status: searchParams.get('status') || '',
    priority: searchParams.get('priority') || '',
    date: searchParams.get('date') || ''
  });

  useEffect(() => {
    fetchTasks();
  }, [filters]);

  const fetchTasks = async () => {
    try {
      setLoading(true);
      const params = {};
      if (filters.status) params.status = filters.status;
      if (filters.priority) params.priority = filters.priority;
      if (filters.date) params.date = filters.date;

      const response = await axios.get('/tasks', { params });
      setTasks(response.data.tasks);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching tasks:', error);
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  const clearFilters = () => {
    setFilters({
      status: '',
      priority: '',
      date: ''
    });
  };

  const getPriorityClass = (priority) => `priority-${priority}`;
  const getPriorityText = (priority) => {
    const map = { high: 'Υψηλή', medium: 'Μεσαία', low: 'Χαμηλή' };
    return map[priority] || priority;
  };
  const getStatusText = (status) => {
    const map = {
      pending: 'Εκκρεμεί',
      in_progress: 'Σε Εξέλιξη',
      completed: 'Ολοκληρώθηκε',
      cancelled: 'Ακυρώθηκε'
    };
    return map[status] || status;
  };

  return (
    <div>
      <Header user={user} onLogout={onLogout} />
      
      <div className="tasks-container">
        <div className="tasks-header">
          <h1>Οι Υποχρεώσεις μου</h1>
          <Link to="/tasks/new" className="btn-primary">
            + Νέα Υποχρέωση
          </Link>
        </div>

        <div className="filters-section">
          <div className="filters">
            <div className="filter-group">
              <label>Κατάσταση:</label>
              <select name="status" value={filters.status} onChange={handleFilterChange}>
                <option value="">Όλες</option>
                <option value="pending">Εκκρεμούν</option>
                <option value="in_progress">Σε Εξέλιξη</option>
                <option value="completed">Ολοκληρωμένες</option>
                <option value="cancelled">Ακυρωμένες</option>
              </select>
            </div>

            <div className="filter-group">
              <label>Προτεραιότητα:</label>
              <select name="priority" value={filters.priority} onChange={handleFilterChange}>
                <option value="">Όλες</option>
                <option value="high">Υψηλή</option>
                <option value="medium">Μεσαία</option>
                <option value="low">Χαμηλή</option>
              </select>
            </div>

            <div className="filter-group">
              <label>Ημερομηνία:</label>
              <input
                type="date"
                name="date"
                value={filters.date}
                onChange={handleFilterChange}
              />
            </div>

            <button onClick={clearFilters} className="btn-clear">
              Καθαρισμός
            </button>
          </div>
        </div>

        {loading ? (
          <div className="loading">Φόρτωση...</div>
        ) : tasks.length === 0 ? (
          <div className="empty-state">
            <p>Δεν βρέθηκαν υποχρεώσεις</p>
            <Link to="/tasks/new" className="btn-secondary">
              Δημιούργησε την πρώτη σου υποχρέωση
            </Link>
          </div>
        ) : (
          <div className="tasks-grid">
            {tasks.map(task => (
              <Link to={`/tasks/${task.id}`} key={task.id} className="task-card">
                <div className="task-card-header">
                  <h3>{task.title}</h3>
                  <span className={`priority-badge ${getPriorityClass(task.priority)}`}>
                    {getPriorityText(task.priority)}
                  </span>
                </div>
                
                {task.description && (
                  <p className="task-description">
                    {task.description.length > 100
                      ? `${task.description.substring(0, 100)}...`
                      : task.description}
                  </p>
                )}
                
                <div className="task-meta">
                  <div className="task-date">
                    📅 {new Date(task.due_date).toLocaleDateString('el-GR')}
                  </div>
                  <div className={`task-status status-${task.status}`}>
                    {getStatusText(task.status)}
                  </div>
                </div>

                {task.assigned_users && task.assigned_users.length > 0 && (
                  <div className="task-users">
                    <span>👥 {task.assigned_users.length} {task.assigned_users.length === 1 ? 'άτομο' : 'άτομα'}</span>
                  </div>
                )}
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default TaskList;
